<app-tab-toolbar [tabId]="'committees'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges && !isCommitteeCarriedForward"
  [showOtherMeasurement]="true" [otherMeasurement]="otherMeasurement"
  [showKeywordsToggle]="true" [keywordsVisible]="showKeywords"
  (keywordsVisibleChange)="showKeywords = $event"
  (yearChange)="onYearChange($event)" (otherMeasurementChange)="onOtherMeasurementChange($event)"
  (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>warning</mat-icon>
      @if (isCommitteeCarriedForward) {
        <span>There is no data for the selected year. Some fields are shown from a previous year.</span>
      } @else {
        <span>There is no data for the selected year</span>
      }
    </div>
  }
</app-tab-toolbar>

<div class="committees-content" [formGroup]="form" [appReadOnlyTab]="'committees'">

  <div class="committees-scroll-area">
  <!-- Board of Directors (unitary) / Supervisory Board (dual) -->
  <div class="board-section">
    <h3 class="section-title">{{ companyBoardType === 0 ? 'Board of Directors' : 'Supervisory Board' }}</h3>

    @if (boardDataSource.data.length === 0) {
      <div class="no-data-message">No data available</div>
    } @else {
    <div class="table-wrapper">
      <table mat-table [dataSource]="boardDataSource" class="committees-table" formArrayName="rows"
             matSort #boardSort="matSort" matSortActive="name" matSortDirection="asc" (matSortChange)="onBoardSort($event)">

        <!-- # Column -->
        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index" class="cell-index" (click)="toggleRowHighlight(row)">{{ i + 1 }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">{{ row.directorFullName }}</td>
        </ng-container>

        <!-- Committee Role Columns -->
        @for (col of committeeColumns; track col.id) {
          <ng-container [matColumnDef]="col.id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ col.header }}</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <select [formControlName]="col.formControl" class="ht-select" [title]="getRoleLabel(col, row[col.formControl])">
                @for (opt of getOptionsForColumn(col); track opt.value) {
                  <option [value]="opt.value" [title]="opt.label">{{ opt.label }}</option>
                }
              </select>
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.row-highlighted]="row.highlighted"></tr>
      </table>
    </div>
    }
  </div>

  <!-- Meetings & Charters -->
  <section class="section-container nrg-border-radius-second-level">
    <div class="section-header">
      <span>Meetings & Charters</span>
    </div>
    <div class="section-content">
      <div class="meetings-charters-grid">
        <div class="row-labels">
          <span class="row-label label-header"></span>
          <span class="row-label">Meetings:</span>
          <span class="row-label">Charters:</span>
        </div>
        <div class="meetings-charters-scroll">
          <div class="meetings-charters-row">
            <div class="meeting-column">
              <label>Audit</label>
              <div class="summary-field-values">
                <input type="text" inputmode="numeric" appNumberFormat formControlName="auditCommitteeMeetings" class="ht-input summary-input-sm">
                @if (otherMeasurement) {
                  <span class="ht-other">{{ formatNumber(otherData?.auditCommitteeMeetings) }}</span>
                }
              </div>
              <mat-checkbox formControlName="audit"></mat-checkbox>
            </div>
            <div class="meeting-column">
              <label>Rem.</label>
              <div class="summary-field-values">
                <input type="text" inputmode="numeric" appNumberFormat formControlName="remCommitteeMeetings" class="ht-input summary-input-sm">
                @if (otherMeasurement) {
                  <span class="ht-other">{{ formatNumber(otherData?.remCommitteeMeetings) }}</span>
                }
              </div>
              <mat-checkbox formControlName="rem"></mat-checkbox>
            </div>
            <div class="meeting-column">
              <label>Nom.</label>
              <div class="summary-field-values">
                <input type="text" inputmode="numeric" appNumberFormat formControlName="nomCommitteeMeetings" class="ht-input summary-input-sm">
                @if (otherMeasurement) {
                  <span class="ht-other">{{ formatNumber(otherData?.nomCommitteeMeetings) }}</span>
                }
              </div>
              <mat-checkbox formControlName="nom"></mat-checkbox>
            </div>
            <div class="meeting-column">
              <label>CG</label>
              <div class="summary-field-values">
                <input type="text" inputmode="numeric" appNumberFormat formControlName="cgCommitteeMeetings" class="ht-input summary-input-sm">
                @if (otherMeasurement) {
                  <span class="ht-other">{{ formatNumber(otherData?.cgCommitteeMeetings) }}</span>
                }
              </div>
            </div>
            <div class="meeting-column">
              <label>Risk</label>
              <div class="summary-field-values">
                <input type="text" inputmode="numeric" appNumberFormat formControlName="riskCommitteeMeetings" class="ht-input summary-input-sm">
                @if (otherMeasurement) {
                  <span class="ht-other">{{ formatNumber(otherData?.riskCommitteeMeetings) }}</span>
                }
              </div>
            </div>
            <div class="meeting-column">
              <label>Fin.</label>
              <div class="summary-field-values">
                <input type="text" inputmode="numeric" appNumberFormat formControlName="financeCommitteeMeetings" class="ht-input summary-input-sm">
                @if (otherMeasurement) {
                  <span class="ht-other">{{ formatNumber(otherData?.financeCommitteeMeetings) }}</span>
                }
              </div>
            </div>
            <div class="meeting-column">
              <label>Inv.</label>
              <div class="summary-field-values">
                <input type="text" inputmode="numeric" appNumberFormat formControlName="investmentCommitteeMeetings" class="ht-input summary-input-sm">
                @if (otherMeasurement) {
                  <span class="ht-other">{{ formatNumber(otherData?.investmentCommitteeMeetings) }}</span>
                }
              </div>
            </div>
            <div class="meeting-column">
              <label>ESG</label>
              <div class="summary-field-values">
                <input type="text" inputmode="numeric" appNumberFormat formControlName="csrCommitteeMeetings" class="ht-input summary-input-sm">
                @if (otherMeasurement) {
                  <span class="ht-other">{{ formatNumber(otherData?.csrCommitteeMeetings) }}</span>
                }
              </div>
            </div>
            <div class="meeting-column">
              <label>Exec.</label>
              <div class="summary-field-values">
                <input type="text" inputmode="numeric" appNumberFormat formControlName="executiveCommitteeMeetings" class="ht-input summary-input-sm">
                @if (otherMeasurement) {
                  <span class="ht-other">{{ formatNumber(otherData?.executiveCommitteeMeetings) }}</span>
                }
              </div>
            </div>
            <div class="meeting-column">
              <label>HR</label>
              <div class="summary-field-values">
                <input type="text" inputmode="numeric" appNumberFormat formControlName="hrCommitteeMeetings" class="ht-input summary-input-sm">
                @if (otherMeasurement) {
                  <span class="ht-other">{{ formatNumber(otherData?.hrCommitteeMeetings) }}</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Management Board (Dual mode only) -->
  @if (companyBoardType !== 0) {
    <div class="board-section">
      <h3 class="section-title">Management Board</h3>

      @if (managementDataSource.data.length === 0) {
        <div class="no-data-message">No data available</div>
      } @else {
      <div class="table-wrapper">
        <table mat-table [dataSource]="managementDataSource" class="committees-table" formArrayName="managementRows"
               matSort #managementSort="matSort" matSortActive="name" matSortDirection="asc" (matSortChange)="onManagementSort($event)">

          <!-- # Column -->
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let row; let i = index" class="cell-index" (click)="toggleRowHighlight(row)">{{ i + 1 }}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let row">{{ row.directorFullName }}</td>
          </ng-container>

          <!-- Committee Role Columns -->
          @for (col of committeeColumns; track col.id) {
            <ng-container [matColumnDef]="col.id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ col.header }}</th>
              <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                <select [formControlName]="col.formControl" class="ht-select" [title]="getRoleLabel(col, row[col.formControl])">
                  @for (opt of getOptionsForColumn(col); track opt.value) {
                    <option [value]="opt.value" [title]="opt.label">{{ opt.label }}</option>
                  }
                </select>
              </td>
            </ng-container>
          }

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.row-highlighted]="row.highlighted"></tr>
        </table>
      </div>
      }
    </div>
  }
  </div>

  <!-- Keywords Section -->
  @if (showKeywords) {
    <div class="board-section keywords-section" formGroupName="keywords">
      <div class="keywords-header">
        <span>Keywords</span>
      </div>
      <div class="keywords-fields">
        <app-keyword-input name="meetings" label="Committee Meetings" />
      </div>
    </div>
  }

  <!-- Comments -->
  <section class="section-container nrg-border-radius-second-level comments-section">
    <div class="section-header">
      <span>Comments</span>
    </div>
    <div class="section-content">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" rows="3"></textarea>
      </mat-form-field>
    </div>
  </section>

</div>
